import React, { useState } from 'react';
import CacheManager from './CacheManager';

const ControlPanel = ({
  roomDimensions,
  onRoomDimensionsChange,
  furniture,
  onAddFurniture,
  onRemoveFurniture,
  onRotateFurniture,
  onDeselect,
  onSelectFurniture,
  selectedFurniture,
  isAddingFurniture,
  setIsAddingFurniture,
  onRestoreLayout,
  onClearCache
}) => {
  const [newFurniture, setNewFurniture] = useState({
    name: '',
    length: 1,
    width: 1,
    height: 1
  });

  const handleAddFurniture = () => {
    if (newFurniture.name && newFurniture.length > 0 && newFurniture.width > 0 && newFurniture.height > 0) {
      onAddFurniture(newFurniture);
      setNewFurniture({ name: '', length: 1, width: 1, height: 1 });
    }
  };

  const handleRemoveSelected = () => {
    if (selectedFurniture) {
      onRemoveFurniture(selectedFurniture);
    }
  };

  return (
    <div className="control-panel">
      <div className="panel-section">
        <h3>房间设置</h3>
        <div className="input-group">
          <label>长度 (米):</label>
          <input
            type="number"
            value={roomDimensions.length}
            onChange={(e) => onRoomDimensionsChange({
              ...roomDimensions,
              length: parseFloat(e.target.value) || 1
            })}
            min="1"
            max="50"
            step="0.5"
          />
        </div>
        <div className="input-group">
          <label>宽度 (米):</label>
          <input
            type="number"
            value={roomDimensions.width}
            onChange={(e) => onRoomDimensionsChange({
              ...roomDimensions,
              width: parseFloat(e.target.value) || 1
            })}
            min="1"
            max="50"
            step="0.5"
          />
        </div>
        <div className="input-group">
          <label>高度 (米):</label>
          <input
            type="number"
            value={roomDimensions.height}
            onChange={(e) => onRoomDimensionsChange({
              ...roomDimensions,
              height: parseFloat(e.target.value) || 1
            })}
            min="1"
            max="10"
            step="0.5"
          />
        </div>
        
        {/* 布局管理按钮 */}
        <CacheManager
          roomDimensions={roomDimensions}
          furniture={furniture}
          onRestoreLayout={onRestoreLayout}
          onClearCache={onClearCache}
        />
      </div>

      <div className="panel-section">
        <h3>添加家具</h3>
        <div className="input-group">
          <label>名称:</label>
          <input
            type="text"
            value={newFurniture.name}
            onChange={(e) => setNewFurniture({ ...newFurniture, name: e.target.value })}
            placeholder="例如: 桌子、椅子、床..."
          />
        </div>
        <div className="input-group">
          <label>长度 (米):</label>
          <input
            type="number"
            value={newFurniture.length}
            onChange={(e) => setNewFurniture({ ...newFurniture, length: parseFloat(e.target.value) || 1 })}
            min="0.1"
            max="20"
            step="0.1"
          />
        </div>
        <div className="input-group">
          <label>宽度 (米):</label>
          <input
            type="number"
            value={newFurniture.width}
            onChange={(e) => setNewFurniture({ ...newFurniture, width: parseFloat(e.target.value) || 1 })}
            min="0.1"
            max="20"
            step="0.1"
          />
        </div>
        <div className="input-group">
          <label>高度 (米):</label>
          <input
            type="number"
            value={newFurniture.height}
            onChange={(e) => setNewFurniture({ ...newFurniture, height: parseFloat(e.target.value) || 1 })}
            min="0.1"
            max="5"
            step="0.1"
          />
        </div>
        <button 
          className="add-button"
          onClick={handleAddFurniture}
          disabled={!newFurniture.name}
        >
          添加家具
        </button>
      </div>

      <div className="panel-section">
        <h3>快速添加</h3>
        <div className="quick-add-buttons">
          <button onClick={() => onAddFurniture({ name: '桌子', length: 1.2, width: 0.6, height: 0.75 })}>
            桌子
          </button>
          <button onClick={() => onAddFurniture({ name: '椅子', length: 0.5, width: 0.5, height: 0.9 })}>
            椅子
          </button>
          <button onClick={() => onAddFurniture({ name: '床', length: 2.0, width: 1.5, height: 0.5 })}>
            床
          </button>
          <button onClick={() => onAddFurniture({ name: '衣柜', length: 1.0, width: 0.6, height: 2.0 })}>
            衣柜
          </button>
          <button onClick={() => onAddFurniture({ name: '沙发', length: 2.0, width: 0.8, height: 0.8 })}>
            沙发
          </button>
        </div>
      </div>

      <div className="panel-section">
        <h3>家具列表 ({furniture.length})</h3>
        <div className="furniture-list">
          {furniture.map((item) => (
            <div 
              key={item.id} 
              className={`furniture-item ${selectedFurniture === item.id ? 'selected' : ''}`}
              onClick={() => onSelectFurniture(item.id)}
            >
              <span>{item.name || `物品 ${item.id}`}</span>
              <button 
                className="remove-button"
                onClick={(e) => {
                  e.stopPropagation(); // 阻止事件冒泡
                  onRemoveFurniture(item.id);
                }}
              >
                删除
              </button>
            </div>
          ))}
          {furniture.length === 0 && (
            <p className="empty-message">暂无家具，请添加一些家具开始规划吧！</p>
          )}
        </div>
        {selectedFurniture && (
          <div className="selected-controls">
            <div className="rotation-controls">
              <label>旋转角度: {Math.round((furniture.find(f => f.id === selectedFurniture)?.rotation[1] || 0) * 180 / Math.PI)}°</label>
              <input
                type="range"
                min="0"
                max="360"
                value={Math.round((furniture.find(f => f.id === selectedFurniture)?.rotation[1] || 0) * 180 / Math.PI)}
                onChange={(e) => {
                  const selectedItem = furniture.find(f => f.id === selectedFurniture);
                  if (selectedItem) {
                    const newRotation = [...selectedItem.rotation];
                    newRotation[1] = (parseInt(e.target.value) * Math.PI) / 180;
                    onRotateFurniture(selectedFurniture, newRotation);
                  }
                }}
                className="rotation-slider"
              />
            </div>
            <div className="action-buttons">
              <button 
                className="rotate-button"
                onClick={() => {
                  const selectedItem = furniture.find(f => f.id === selectedFurniture);
                  if (selectedItem) {
                    const newRotation = [...selectedItem.rotation];
                    newRotation[1] += Math.PI / 2;
                    onRotateFurniture(selectedFurniture, newRotation);
                  }
                }}
              >
                旋转90度
              </button>
            </div>
            <div className="button-group">
              <button 
                className="deselect-button"
                onClick={onDeselect}
              >
                取消选中
              </button>
              <button 
                className="remove-selected-button"
                onClick={handleRemoveSelected}
              >
                删除选中物品
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="panel-section">
        <h3>操作说明</h3>
        <div className="instructions">
          <p>• 点击家具或列表项：选中家具</p>
          <p>• 第二次点击选中家具：开始拖拽</p>
          <p>• 双击：旋转家具90度</p>
          <p>• 选中后使用角度滑块精确调整</p>
          <p>• 点击"取消选中"按钮取消选中</p>
          <p>• 鼠标滚轮：缩放视图</p>
          <p>• 右键拖拽：旋转视角</p>
          <p>• 中键拖拽：平移视角</p>
        </div>
      </div>
    </div>
  );
};

export default ControlPanel; 